import { Dispatch, ReactNode, SetStateAction } from 'react';
import { Editor, EditorState, RichUtils } from 'draft-js';
import 'draft-js/dist/Draft.css';
import { Divider, IconButton, Stack } from '@mui/material';
import {
  FormatBold,
  FormatItalic,
  FormatListBulleted,
  FormatListNumbered,
} from '@mui/icons-material';
import Frame from '@/components/Frame';

interface Style {
  icon: ReactNode;
  label: string;
  style?: string;
  block?: string;
}

const STYLES: Style[] = [
  {
    icon: <FormatBold />,
    label: 'Negrita',
    style: 'BOLD',
  },
  {
    icon: <FormatItalic />,
    label: 'Inclinada',
    style: 'ITALIC',
  },
  {
    icon: <FormatListBulleted />,
    label: 'Viñetas',
    block: 'unordered-list-item',
  },
  {
    icon: <FormatListNumbered />,
    label: 'Lista Ordenada',
    block: 'ordered-list-item',
  },
];

interface Props {
  value: EditorState;
  onChange: Dispatch<SetStateAction<EditorState>>;
}

const WysiwygEditor = ({ value, onChange }: Props) => {
  const applyStyle = (style: 'string') => {
    onChange(RichUtils.toggleInlineStyle(value, style));
  };

  const applyBlock = (block: 'string') => {
    onChange(RichUtils.toggleBlockType(value, block));
  };

  const isActive = (style: unknown) => {
    const currentStyle = value.getCurrentInlineStyle();
    return currentStyle.has(style);
  };

  return (
    <Frame padding={0}>
      <Stack direction="row" spacing={2} px={1} py={1}>
        {STYLES.map((style) => {
          if (style?.style) {
            return (
              <IconButton
                key={style.label}
                size="small"
                color={isActive(style.style) ? 'primary' : 'default'}
                onClick={() => applyStyle(style.style)}
              >
                {style.icon}
              </IconButton>
            );
          } else if (style?.block) {
            return (
              <IconButton
                key={style.label}
                size="small"
                color={isActive(style.block) ? 'primary' : 'default'}
                onClick={() => applyBlock(style.block)}
              >
                {style.icon}
              </IconButton>
            );
          }
        })}
      </Stack>
      <Divider />
      <Stack px={2} py={1} sx={{ minHeight: 100 }}>
        <Editor editorState={value} onChange={onChange} />
      </Stack>
    </Frame>
  );
};

export default WysiwygEditor;
